import styled from 'styled-components';
import UIExpandingTextArea from 'UIComponents/input/UIExpandingTextArea';
import UICharacterCounter from 'UIComponents/counters/UICharacterCounter';
import { LORAX } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const MaxLengthWarningCount = styled.div.withConfig({
  displayName: "MultilineCharacterCounter__MaxLengthWarningCount",
  componentId: "sc-1x3zgqo-0"
})(["border-top:1px solid ", ";color:", ";width:688px;text-align:right;"], LORAX, LORAX);
const MultilineCharacterCounter = props => /*#__PURE__*/_jsx(UICharacterCounter, {
  className: "kb-character-counter",
  counter: "down",
  label: ({
    count
  }) => count < props.maxLengthWarningThreshold ? /*#__PURE__*/_jsx(MaxLengthWarningCount, {
    children: count
  }) : null,
  maxLength: props.maxLength,
  onBlur: props.onBlur,
  onChange: props.onChange,
  renderInput: ({
    value,
    onChange,
    onBlur
  }) => /*#__PURE__*/_jsx(props.textAreaComponent, {
    "data-test-id": props['data-test-id'],
    disabled: props.disabled,
    className: props.className,
    inputRef: props.inputRef,
    maxLength: props.maxLength,
    onBlur: onBlur,
    onChange: onChange,
    placeholder: props.placeholder,
    shrink: true,
    styled: false,
    value: value
  }),
  value: props.value
});
MultilineCharacterCounter.defaultProps = {
  textAreaComponent: UIExpandingTextArea
};
export default MultilineCharacterCounter;